import { IMassUnit, IMassUnitObject } from '../../sp-types/massUnitType';

const conversionToMetricTon: Record<IMassUnit, number> = {
  shortTon: 0.907185,
  metricTon: 1,
  grossTon: 1.01605,
  hundredweight: 0.0453592,
  cwt: 0.0453592,
  bbl: 1,
  libra: 1,
  lbs: 1,
  currency: 1,
  None: 1,
};

const conversionFromMetricTon: Record<IMassUnit, number> = {
  shortTon: 1 / 0.907185,
  metricTon: 1,
  grossTon: 1 / 1.01605,
  hundredweight: 1 / 0.0453592,
  cwt: 1 / 0.0453592,
  bbl: 1,
  libra: 1,
  lbs: 1,
  currency: 1,
  None: 1,
};
export const getUnitObj = (unit?: string): IMassUnitObject => MassUnitsDict[(unit || 'metricTon') as IMassUnit];
export const MassUnitsDict: Record<IMassUnit, IMassUnitObject> = {
  shortTon: {
    displayName: 'Short ton',
    shortForm: 'st',
    convertPrice: (value: number) => value * conversionToMetricTon['shortTon'],
    convertMetricTonToUnit: (value: number) => value * conversionFromMetricTon['shortTon'],
  },
  metricTon: {
    displayName: 'Metric ton',
    shortForm: 'mt',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
  currency: {
    displayName: 'Currency',
    shortForm: 'crcy',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
  grossTon: {
    displayName: 'Gross ton',
    shortForm: 'gt',
    convertPrice: (value: number) => value * conversionToMetricTon['grossTon'],
    convertMetricTonToUnit: (value: number) => value * conversionFromMetricTon['grossTon'],
  },
  hundredweight: {
    displayName: 'Hundredweight',
    shortForm: 'cwt',
    convertPrice: (value: number) => value * conversionToMetricTon['hundredweight'],
    convertMetricTonToUnit: (value: number) => value * conversionFromMetricTon['hundredweight'],
  },
  cwt: {
    displayName: 'Hundredweight',
    shortForm: 'cwt',
    convertPrice: (value: number) => value * conversionToMetricTon['hundredweight'],
    convertMetricTonToUnit: (value: number) => value * conversionFromMetricTon['hundredweight'],
  },
  bbl: {
    displayName: 'Barrel',
    shortForm: 'bbl',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
  libra: {
    displayName: 'Libra',
    shortForm: 'lbs',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
  lbs: {
    displayName: 'Libra',
    shortForm: 'lbs',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
  None: {
    displayName: ' ',
    shortForm: ' ',
    convertPrice: (value: number) => value,
    convertMetricTonToUnit: (value: number) => value,
  },
};

export const getAllMassUnitOptions = (): IMassUnit[] => {
  return Object.keys(MassUnitsDict) as IMassUnit[];
};
